import { showMessage } from "../customhooks/useNotifier";
import environment from "../environments/environment";
import fetchWithAuthRetry from "./fetchWithAuthRetry";

const chatwidgetService = {
  checkWebsite: async (payload) => {
    console.log("checkWebsite payload-----", payload, environment);
    try {
      // const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      // const token = currentUser?.token || "";

      const response = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/check-website`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: token ? `Bearer ${token}` : "",
          },
          body: JSON.stringify(payload),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.error || "Failed to check website");
      }

      return responseData;
    } catch (error) {
      console.error("checkWebsite error:", error.message);
      return { allowed: false, error: error.message };
    }
  },
  createChatUser: async ({ name, email, websiteid }) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/chatuser`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, websiteid }),
      },
    );

    if (!res.ok) throw new Error("Failed to create user");
    return res.json();
  },
  createChatSession: async (userId, sessionId, kbId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/chatsession/${userId}/${sessionId}/${kbId}`,
      {
        method: "POST",
      },
    );

    if (!res.ok) throw new Error("Failed to create session");
    return res.json();
  },
  syncToDBChatMessage: async (
    userId,
    sessionId,
    question,
    answer,
    completeResponse,
    kbId,
  ) => {
    try {
      const payload = {
        userId,
        sessionId,
        question,
        answer,
        completeResponse,
        kbId,
      };
      // console.log("syncToDBChatMessage payload ----->", payload);
      const res = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/handleMessages`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) {
        throw new Error("Failed to send message");
      }

      const responseData = await res.json();
      return responseData;
    } catch (error) {
      console.error("sendMessage error:", error.message);
      throw new Error(error.message);
    }
  },
  submitFeedback: async (messageId, feedback) => {
    try {
      const res = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ messageId, feedback }),
        },
      );

      if (!res.ok) {
        throw new Error("Failed to submit feedback");
      }

      return await res.json();
    } catch (error) {
      console.error("submitFeedback error:", error.message);
      throw error;
    }
  },
  getChatMessages: async (sessionId) => {
    try {
      const res = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/chatwidget/getchatmessages/${sessionId}`,
        {
          method: "GET",
        },
      );

      if (!res.ok) {
        throw new Error("Failed to retrieve messages");
      }

      const responseData = await res.json();
      return responseData;
    } catch (error) {
      console.error("getMessages error:", error.message);
      throw new Error(error.message);
    }
  },
  handleSendMessageStaticMsg: async (payload, onMessageUpdate) => {
    try {
      console.log("MOCK handleSendMessage payload ---->", payload);

      // -------- STATIC STREAMING CHUNKS --------
      const mockChunks = [
        `data: ${JSON.stringify({ output: "Hello ", is_completed: false })}`,
        `data: ${JSON.stringify({ output: "this is ", is_completed: false })}`,
        `data: ${JSON.stringify({ output: "a static ", is_completed: false })}`,
        `data: ${JSON.stringify({
          output: "streaming response.",
          is_completed: false,
        })}`,
        `data: ${JSON.stringify({
          output: "Hello this is a static streaming response.",
          ans: [{ title: "Mock Reference", link: "https://example.com" }],
          session_id: "static-session-124",
          is_completed: true,
        })}`,
      ];

      let accumulatedMessage = "";
      const receivedChunks = new Set();

      for (const rawChunk of mockChunks) {
        // simulate delay like actual streaming
        await new Promise((resolve) => setTimeout(resolve, 300));

        const line = rawChunk.trim();
        const jsonString = line.startsWith("data:")
          ? line.substring(5).trim()
          : line;

        try {
          const jsonData = JSON.parse(jsonString);

          const chunkId = JSON.stringify(jsonData);
          if (receivedChunks.has(chunkId)) continue;
          receivedChunks.add(chunkId);

          // ------- FINAL CHUNK -------
          if (jsonData.is_completed) {
            console.log("=== MOCK STREAM COMPLETED ===");
            console.log("Final message:", jsonData.output);

            onMessageUpdate({
              output: formatText(removeMarkers(jsonData.output)),
              ans: jsonData.ans,
              is_completed: true,
              session_id: jsonData.session_id,
            });

            return jsonData;
          }

          // ------- STREAM PARTIAL CHUNK -------
          if (jsonData.output) {
            accumulatedMessage += jsonData.output;
            onMessageUpdate(formatText(removeMarkers(accumulatedMessage)));
          }
        } catch (err) {
          console.error("Error parsing mock JSON chunk:", err);
        }
      }
    } catch (error) {
      console.error("MOCK Error in handleSendMessage:", error);
      throw error;
    }
  },
  handleSendMessageOld: async (payload, onMessageUpdate) => {
    try {
      console.log("handleSendMessage payload ---->", payload);

      // Use the endpoint directly without trailing slash to avoid redirect issues
      // Remove trailing slash and ensure we use HTTPS to avoid redirects
      let chatApiUrl =
        process.env.REACT_APP_CHAT_API?.replace(/\/$/, "") ||
        "https://api.sitepilot.online/rag/chat";
      // Ensure HTTPS to avoid redirect issues
      if (chatApiUrl.startsWith("http://")) {
        chatApiUrl = chatApiUrl.replace("http://", "https://");
      }

      const response = await fetch(chatApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      console.log("handleSendMessage response---->", response);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedMessage = "";
      const receivedChunks = new Set();

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const lines = chunk.split("\n");

        for (const line of lines) {
          if (!line.trim()) continue;

          try {
            // Handle SSE format with "data:" prefix
            const jsonString = line.startsWith("data:")
              ? line.substring(5).trim()
              : line.trim();
            if (!jsonString) continue;

            const jsonData = JSON.parse(jsonString);
            const chunkId = JSON.stringify(jsonData);

            if (receivedChunks.has(chunkId)) continue;
            receivedChunks.add(chunkId);

            if (jsonData.is_completed) {
              console.log("=== STREAM COMPLETED ===");
              console.log("Final message:", jsonData.output);
              console.log("References:", jsonData.ans);
              console.log("Session ID:", jsonData.session_id);
              console.log("=====================");

              onMessageUpdate({
                // output: jsonData.output,
                output: formatText(removeMarkers(jsonData.output)),
                ans: jsonData.ans,
                is_completed: true,
                session_id: jsonData.session_id,
              });
              return jsonData;
            }

            // if (jsonData.output) {
            //   accumulatedMessage += jsonData.output;
            //   onMessageUpdate(accumulatedMessage);
            // }

            if (jsonData.output) {
              accumulatedMessage += jsonData.output;
              onMessageUpdate(formatText(removeMarkers(accumulatedMessage)));
            }
          } catch (e) {
            console.error("Error parsing JSON:", e);
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSendMessage:", error);
      throw error;
    }
  },
  handleSendMessage: async (payload, onMessageUpdate) => {
    try {
      console.log("handleSendMessage payload ---->", payload);

      let chatApiUrl =
        process.env.REACT_APP_CHAT_API?.replace(/\/$/, "") ||
        "https://api.sitepilot.online/rag/chat";

      if (chatApiUrl.startsWith("http://")) {
        chatApiUrl = chatApiUrl.replace("http://", "https://");
      }

      const response = await fetch(chatApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      let buffer = "";
      let accumulatedMessage = "";
      const receivedChunks = new Set();

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });

        // SSE events end with \n\n
        const events = buffer.split("\n\n");
        buffer = events.pop(); // keep incomplete part

        for (const event of events) {
          const line = event.trim();
          if (!line.startsWith("data:")) continue;

          const jsonString = line.replace(/^data:\s*/, "");

          // Guard against partial / plain text chunks
          if (!jsonString.startsWith("{") || !jsonString.endsWith("}")) {
            continue;
          }

          let jsonData;
          try {
            jsonData = JSON.parse(jsonString);
          } catch {
            // Streaming JSON can be partial — ignore safely
            continue;
          }

          const chunkId = JSON.stringify(jsonData);
          if (receivedChunks.has(chunkId)) continue;
          receivedChunks.add(chunkId);

          // ✅ Stream completed
          if (jsonData.is_completed) {
            onMessageUpdate({
              output: formatText(removeMarkers(jsonData.output || "")),
              ans: jsonData.ans,
              is_completed: true,
              session_id: jsonData.session_id,
            });
            return jsonData;
          }

          // ✅ Streaming output
          if (jsonData.output) {
            accumulatedMessage += jsonData.output;
            // onMessageUpdate(formatText(removeMarkers(accumulatedMessage)));
            onMessageUpdate({
              output: formatText(removeMarkers(accumulatedMessage)),
              is_completed: false,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error in handleSendMessage:", error);
      throw error;
    }
  },

  getDocument: async (documentId, ext = "pdf") => {
    // const baseUrl = process.env.REACT_APP_DOC_URL;
    //https://api.sitepilot.online/rag/document/get/39e71b64695411f0922e0242ac130005
    const url = `https://api.sitepilot.online/rag/document/get/${documentId}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Failed to fetch document: ${response.status} ${errorText}`,
        );
      }

      const blob = await response.blob();

      // Optional: Validate MIME type if you expect PDFs only
      if (ext === "pdf" && blob.type !== "application/pdf") {
        throw new Error("Invalid document type received. Expected a PDF.");
      }

      return blob;
    } catch (error) {
      console.error("Error fetching document:", error);
      throw error;
    }
  },
  // ---------------------------
  // Google Events Manage
  // ---------------------------
  getConnection: async (userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/get-public-connection?userId=${userId}`,
      {
        method: "GET",
      },
    );
    if (!res.ok) throw new Error("Failed to fetch connection");
    return res.json();
  },

  getAuthUrl: async (userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/auth-public-url?userId=${userId}`,
      {
        method: "GET",
      },
    );
    if (!res.ok) throw new Error("Failed to get Google auth URL");
    return res.json();
  },

  findAvailability: async (data, userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/find-public-availability`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, userId }),
      },
    );

    if (!res.ok) throw new Error("Failed to check availability");
    const json = await res.json();
    return json.data || [];
  },

  listEvents: async (data, userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/list-public-events`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, userId }),
      },
    );

    return handleResponse(res, null, "Failed to fetch events");
  },

  createEvent: async (data, userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/create-public-event`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, userId }),
      },
    );

    return handleResponse(
      res,
      "Event created successfully",
      "Failed to create event",
    );
  },

  updateEvent: async (data, userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/update-public-event`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, userId }),
      },
    );

    return handleResponse(
      res,
      "Event updated successfully",
      "Failed to update event",
    );
  },

  deleteEvent: async (data, userId) => {
    const res = await fetch(
      `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/delete-public-event`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...data, userId }),
      },
    );

    return handleResponse(
      res,
      "Event delete successfully",
      "Failed to delete event",
    );
  },

  /** ----------------- New Email Leads functions ----------------- */

  createEmailLead: async (data) => {
    try {
      const res = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/email-leads`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        },
      );

      if (!res.ok) throw new Error("Failed to create email lead");
      return res.json();
    } catch (err) {
      console.error("❌ createEmailLead error:", err);
      throw err;
    }
  },

  getEmailLeads: async (status) => {
    try {
      const url = new URL(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/email-leads`,
      );

      if (status) url.searchParams.append("status", status);

      const res = await fetch(url.toString(), {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) throw new Error("Failed to fetch email leads");
      return res.json();
    } catch (err) {
      console.error("❌ getEmailLeads error:", err);
      return [];
    }
  },

  updateEmailLeadStatus: async (leadId, status) => {
    try {
      const res = await fetch(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/email-leads/${leadId}/status`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ status }),
        },
      );

      if (!res.ok) throw new Error("Failed to update email lead status");
      return res.json();
    } catch (err) {
      console.error("❌ updateEmailLeadStatus error:", err);
      throw err;
    }
  },

  searchEmailLeads: async (filters) => {
    try {
      const url = new URL(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/email-leads/search`,
      );

      Object.entries(filters).forEach(([key, val]) => {
        if (val) url.searchParams.append(key, val);
      });

      const res = await fetch(url.toString(), {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) throw new Error("Failed to search email leads");
      return res.json();
    } catch (err) {
      console.error("❌ searchEmailLeads error:", err);
      return [];
    }
  },

  updateEmailLead: async (leadId, data) => {
    try {
      const response = await fetchWithAuthRetry(
        `${environment.REACT_APP_BACKEND_API_BASE_URL}/api/v1/actions/email-leads/${leadId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        },
      );

      return handleResponse(
        response,
        "Email lead updated successfully",
        "Failed to update email lead",
      );
    } catch (error) {
      console.error("❌ updateEmailLead error:", error);
      throw error;
    }
  },
};

const removeMarkers = (text = "") => {
  return text.replace(/##\d+\$\$/g, "");
};

const formatText = (text = "") => {
  return text
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\n{2,}/g, "<br><br>")
    .replace(/([^\n])\n([^\n])/g, "$1<br>$2")
    .replace(/-\s*<br>/g, "-");
};

export default chatwidgetService;

async function handleResponse(response, successMessage, errorMessage) {
  let result;
  try {
    result = await response.json();
  } catch {
    throw new Error("Invalid server response");
  }

  if (!response.ok || result?.success === false) {
    // special case: no Google connection
    if (result?.message === "No Google connection found") {
      return null; // just return null instead of error/toast
    }

    // special case: Workiz JobTypes not available
    if (result?.message?.includes("Workiz getJobTypes failed")) {
      console.error("⚠️ Workiz job types error:", result?.message);
      return null; // suppress toast + error, just return null
    }

    const msg = result?.message || errorMessage;
    showMessage(msg, "error");
    throw new Error(msg);
  }

  if (successMessage) {
    showMessage(result.message || successMessage, "success");
  }

  return result.data ?? result ?? null;
}
